import { render, staticRenderFns } from "./OffersDelete.vue?vue&type=template&id=f0eb3b86&scoped=true"
import script from "./OffersDelete.vue?vue&type=script&lang=js"
export * from "./OffersDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eb3b86",
  null
  
)

export default component.exports